import { Component } from '@angular/core';
import {DxBaseCellRenderComponent} from "../dx-base-cell-render.component";
import {ICellRendererParams} from 'ag-grid-community';

@Component({
  selector: 'app-dx-checkbox-cell-render',
  templateUrl: './dx-checkbox-cell-render.component.html',
  styleUrls: ['./dx-checkbox-cell-render.component.css']
})
export class DxCheckboxCellRenderComponent extends DxBaseCellRenderComponent  {

  constructor() {
    super();
  }

  /** Значение чекбокса */
  public cbValue: boolean;
  public readOnly: boolean;

  onClick(): void {
    this.cbValue = !this.cbValue;
    this._params.setValue(this.cbValue);
  }


  protected _init(params: ICellRendererParams): void {
    super._init(params);
    this.cbValue = params.value;
    this.readOnly = !params.colDef.editable;

  }


}
